import { cn } from "@/shared/utils/cn";
import Center from "../Base/Center";
import { DeleteIcon } from "../DeleteIcon";

interface DeletableTextProps {
  text: string;
  deleteText?: () => void;
  className?: string;
}

const DeletableText = ({ text, deleteText, className }: DeletableTextProps) => {
  return (
    <Center className="flex items-center">
      <div
        onClick={(e) => {
          e.stopPropagation();
          deleteText?.();
        }}
      >
        <DeleteIcon size="small" />
      </div>
      <span className={cn("ml-2", className)}>{text}</span>
    </Center>
  );
};

export default DeletableText;
